import UserGroupDeleteForm from "./usergroup-delete-form";

export default UserGroupDeleteForm;